export default __webpack_public_path__ + "static/media/calendar_icon.115d6224.svg";